import { OverlayTrigger, Tooltip } from "react-bootstrap";
import PropTypes from "prop-types";
import { getSewStatusColor } from "../utils/Utils";

/**
 * Renders a colored circle denoting a SEW system's readiness status.
 * Hovering shows the raw status text.
 */
const StatusIndicator = ({ status, size = 12 }) => {
    const { color, needsOutline } = getSewStatusColor(status);

    const circle = (
        <span
            style={{
                display: "inline-block",
                width: `${size}px`,
                height: `${size}px`,
                borderRadius: "50%",
                backgroundColor: color,
                border: needsOutline ? "1px solid #ffffff88" : "none",
                flexShrink: 0
            }}
        />
    );

    if (!status) {
        return circle;
    }

    return (
        <OverlayTrigger placement="top" overlay={<Tooltip id="status-tooltip">{status}</Tooltip>}>
            {circle}
        </OverlayTrigger>
    );
};

StatusIndicator.propTypes = {
    status: PropTypes.string,
    size: PropTypes.number
};

export default StatusIndicator;
